export default "__VITE_ASSET__DytDkOVc__"